import Vue from "vue";
import AppModals from "@/components/ui/modal/Component";

export default Vue.extend({
  name: "AppWrapper",

  components: { AppModals },

  props: {
    id: {
      type: String,
      default: "app"
    }
  },

  render(h) {
    const wrapper = h(
      "div",
      { staticClass: "application_wrap" },
      this.$slots.default
    );

    return h(
      "div",
      {
        staticClass: "application",
        attrs: { "data-app": true },
        domProps: { id: this.id }
      },
      [wrapper, h("app-modals")]
    );
  }
});
